import React from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import { Button, Image } from 'semantic-ui-react';

import { getSizeIncrement } from '#/shared/components/utils/Avatar';

const defaultProfilePic = '/static/img/defaultProfilePic.png';
const SimpleAvatar = observer(
  ({ imageURL, className = 'w-100 h-100', imgStyle }) =>
    _.isEmpty(imageURL) || imageURL === defaultProfilePic ? (
      <div className={className}>
        <Button
          circular={true}
          color="blue"
          compact={true}
          icon="user"
          size={getSizeIncrement(className)}
        />
      </div>
    ) : (
      <Image
        alt="avatar"
        circular={true}
        className={className}
        src={imageURL}
        style={imgStyle}
      />
    ),
);

export { SimpleAvatar };
